import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import { Toaster } from 'react-hot-toast';
import Home from './components/Home';
import Mkt from './components/Mkt';
import Search from './components/Search';
import ViewLocal from './components/ViewLocal';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Map from './components/Map';
import './styles/globals.css';


function App() {
  return (
    <BrowserRouter>   
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '8px',
          },
        }}
      />
      
      <Routes>        
        <Route path="/" element={<Home />} />
        <Route path="/mercado/:id" element={<Mkt />} />
        <Route path="/search/:id" element={<Search />} />
        <Route path="/mercado/:mercadoId/local/:localId" element={<ViewLocal />} />
        <Route path="/privacidad" element={<Privacy />} />
        <Route path="/terminos" element={<Terms />} />
        <Route path="/mapa" element={<Map />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;